// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__U+frc","tabWrapper":"styles_tabWrapper__Wj9Y5","trash":"styles_trash__SCUGc","custom":"styles_custom__ucScx"};